import Card from "@components/Card";
import Loader from "@components/Loader";
import { useProjectActions, useProjectContext } from "@contexts/projects";
import { dateToString, formatNumberToCurrency } from "@utils/formatNumber";
import { useEffect, useState } from "react";
import LoaderItem from "../value/accordion/LoaderItem";
import Select, { components } from 'react-select';
import { useAuthContext } from "@contexts/auth";

const OffcanvasLessons = () => {
  const { selectedDetail: { item }, companies, activeProject } = useProjectContext();
  const { getLessons, updateLessons } = useProjectActions();
  const { user } = useAuthContext();
  const [toggle, setToggle] = useState(false)
  const [newLesson, setNewLesson] = useState('')
  const [lessons, setLessons] = useState([])
  const [loading, setLoading] = useState(false)
  const [newTags, setNewTags] = useState([])

  const currentCompany = companies?.filter(i => i._id === activeProject?.company_id)[0]

  const CustomOption = (props) => {

    return (
      <components.Option {...props}>
        <div>
          <span style={{ backgroundColor: currentCompany.tags.filter(i => i.name === props.data.label)[0].color, fontWeight: 'bold', padding: '4px 8px', color: 'white', borderRadius: '32px' }}>{props.data.label}</span>
        </div>
      </components.Option>
    );
  };

  useEffect(() => {
    setLessons([])
    if (toggle) {
      getItens()
    }
  }, [toggle])

  useEffect(() => {
    setToggle(false)
  }, [item])

  const getItens = async () => {
    setLoading(true)
    const lessons = await getLessons(item.wbs_code_id)
    setLessons(lessons.response)
    setLoading(false)
  }

  const handleChange = (e) => {
    e.preventDefault()
    setNewLesson(e.target.value)
  }

  const handleSend = async () => {
    const res = await updateLessons(item.wbs_code_id, newLesson, '', item.description === undefined ? item.building_unit_name : item.description, 'false', newTags, user.email)
    if (res.code === 200) {
      setLessons([...lessons, { lesson: newLesson, _id: res.newId }])
      setNewLesson('')
    }
  }

  const handleDelete = async (id) => {
    const res = await updateLessons(item.wbs_code_id, newLesson, id, item.description, 'true')
    if (res.code === 200) {
      const updatedLessons = lessons.filter(i => i._id !== id)
      setLessons(updatedLessons)
    }
  }

  const handleTags = (e) => {
    setNewTags(e.map(i => i.value))

  }

  return <>
    <div className="margin-bottom-8 flex align-center margin-top-12">
      <button
        className={`accordion-toggle ${toggle ? "active" : ""}`}
        onClick={() => setToggle(!toggle)}
      />
      <span style={{ fontWeight: "bold", fontSize: '22px' }}>Lições aprendidas</span>
    </div>
    {toggle && loading && <LoaderItem />}
    {toggle && <>
      <div className="accordion">
        {lessons.length > 0 && lessons.map(i => {
          return <div className="accordion-item-body flex align-center" key={i._id}>
            <p className="column-span-2-tablet" style={{ marginTop: '0px' }}>{i.lesson}</p>
            <button className="button button-error small" onClick={() => handleDelete(i._id)}>Deletar</button>
          </div>
        })}
      </div>
      <div className="flex gap-16 align-center margin-top-8 margin-bottom-8">
        <input
          style={{ marginBottom: '0px', width: '100%' }}
          className="resource-search"
          type="text"
          name="value"
          value={newLesson}
          onChange={handleChange}
          placeholder="Nova lição"
        />
        <Select
          style={{ width: '100%' }}
          isMulti
          isClearable={false}
          value={newTags?.map(i => ({ value: i, label: i }))}
          name="tags"
          options={currentCompany?.tags?.map(i => ({ value: i.name, label: i.name }))}
          onChange={handleTags}
          components={{ Option: CustomOption }}
          className="basic-multi-select full-width"
          classNamePrefix="select"
          placeholder='Tags'
        />
        <button onClick={handleSend} className="button button-accent small">Enviar</button>
      </div>
    </>}
  </>
}

export default OffcanvasLessons;